<app-widget titleT="DOCUMENTS.cockpit.document-widget.title" [navigateLink]="navigateLibrariesLink"
    [itemsCount]="(documentLibraries$ | async)?.length" [loading]="(loadingService.loading$ | async)!">

    <div *appShowAuthorize="'CUSTOMER_SPACE_WRITE'" class="slot-action-button">
        <app-button-icon-add *ngIf="(documentLibraries$ | async)!.length === 0"
            (click)="navigation.navigateCreateLibrary(customerSpaceId)"
            [tooltip]="'DOCUMENTS.cockpit.document-widget.new-library' | translate" />
    </div>

    <app-document-widget-table [documentLibraries]="documentLibraries$" [customerSpaceId]="customerSpaceId"
        [displayRowsCount]="displayRowsCount">
    </app-document-widget-table>

    <a *ngIf="showAll$ | async" [routerLink]="navigateLibrariesLink" class="slot-footer">{{
        'FIDUCIARY.cockpit.documents-widget.show-all-link' | translate }}</a>
</app-widget>